import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  expiredStatus,
  selectCurrentAccessToken,
  selectCurrentScope,
} from "./authSlice";

const MemberRequried = () => {
  const accessToken = useSelector(selectCurrentAccessToken);
  const scope = useSelector(selectCurrentScope);
  const location = useLocation();
  const isActive = useSelector(expiredStatus) === 0;

  return accessToken && scope === "PORTAL_MEMBER" && isActive ? (
    <Outlet />
  ) : accessToken && scope === "PORTAL_MEMBER" ? (
    <Navigate to="/renew" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default MemberRequried;
